const angular = require('angular');

const analyticsEvents = require('./events.constants');
const tagManagers = require('./tag-managers.constants');
const mapperTypes = require('./mapper-types.constants');
const { analyticsOnClickDirectiveDefinition } = require('./analytics-on-click.directive');
const AnalyticsService = require('./analytics.service');
const analyticsInputDirectiveDefinition = require('./analytics-input.directive');
const analyticsFormErrorsDirectiveDefinition = require('./analytics-form-errors.directive');

const analyticsModuleName = 'wowApp.analytics';

angular.module(analyticsModuleName, [])
    .constant('AnalyticsEvents', analyticsEvents)
    .constant('AnalyticsTagManagers', tagManagers)
    .constant('AnalyticsMappertypes', mapperTypes)
    .service('AnalyticsService', AnalyticsService)
    .directive('olyAnalyticsOnClick', analyticsOnClickDirectiveDefinition)
    .directive('analyticsInput', ['AnalyticsService', analyticsInputDirectiveDefinition])
    .directive('wowAnalyticsFormErrors', ['AnalyticsService', analyticsFormErrorsDirectiveDefinition]);

module.exports = analyticsModuleName;



// WEBPACK FOOTER //
// ./src/analytics/analytics.module.js